module.exports = __webpack_public_path__ + "img/privacy_cn.0da916c.jpg";